import React from "react";
import { Photo } from "@/types/photos";
import { FileText } from "lucide-react";
import FadeIn from "@/components/FadeIn";
import PhotoCard from "@/components/PhotoCard";

interface ApprovedPhotosTabProps {
  photos: Photo[];
  onDownload: (id: string) => void;
}

const ApprovedPhotosTab: React.FC<ApprovedPhotosTabProps> = ({
  photos,
  onDownload,
}) => {
  return (
    <>
      {photos.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
          {photos.map((photo, index) => (
            <FadeIn key={photo.id} delay={index * 50}>
              <PhotoCard
                {...photo}
                onDownload={onDownload}
              />
            </FadeIn>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 md:py-12">
          <div className="flex justify-center mb-4 text-muted-foreground">
            <FileText className="h-12 w-12 md:h-16 md:w-16" />
          </div>
          <h3 className="text-base md:text-lg font-medium">No approved photos</h3>
          <p className="text-sm md:text-base text-muted-foreground">
            Approve some photos to see them here
          </p>
        </div>
      )}
    </>
  );
};

export default ApprovedPhotosTab;
